var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M22.5 9L12.5 5L2.5 9L12.5 13L22.5 9ZM22.5 9V15M6.5 10.6001V16.0001C6.5 16.7957 7.13214 17.5588 8.25736 18.1214C9.38258 18.684 10.9087 19.0001 12.5 19.0001C14.0913 19.0001 15.6174 18.684 16.7426 18.1214C17.8679 17.5588 18.5 16.7957 18.5 16.0001V10.6001", stroke: "#606060", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});